import { Component } from '@angular/core';

@Component({
  selector: 'app-blank-layout',
  templateUrl: './blank-layout.component.html',
  standalone: false,
  styleUrls: ['./blank-layout.component.scss'],
})
export class BlankLayoutComponent {

}
